import { merge } from "lodash-es"
import {
  WITHDRAWAL_LIMIT_DESER,
  WithdrawalLimit,
} from "../../tastyworks/cash-management"
import type HttpClient from "../../tastyworks/http"
import type { Params } from "../../tastyworks/request"
import type { SingleResponse } from "../../tastyworks/response"

type PARTNER = "TastyFX" // Add a union if and when we support other partners

export class WithdrawalLimitService {
  constructor(private readonly accountNumberClient: HttpClient) {}

  readonly show = async (
    accountNumber: string,
    achRelationshipId?: string,
    partner?: PARTNER
  ): Promise<SingleResponse<WithdrawalLimit>> =>
    this.accountNumberClient.show(
      new WithdrawalLimit(),
      WITHDRAWAL_LIMIT_DESER.update,
      "withdrawal-limits",
      merge({ accountNumber, achRelationshipId, partner }) as Params
    )
}
